<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 19"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      d="M6.279 11.95h-.858L0 17.38 1.619 19l5.431-5.42v-.859l.294-.304a7.03 7.03 0 0 0 4.595 1.705 7.061 7.061 0 1 0-7.061-7.06 7.03 7.03 0 0 0 1.705 4.594l-.304.294zM16.828 7.06a4.882 4.882 0 0 1-4.889 4.889A4.882 4.882 0 0 1 7.051 7.06a4.882 4.882 0 0 1 4.888-4.888 4.882 4.882 0 0 1 4.889 4.888z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSearch',
};
</script>
